<template>
  <div class="allBox">
    <div class="title">
      <strong @click="$router.go(-1)" style="cursor: pointer"><i class="el-icon-back"></i></strong>
      <span>新增桌台区域</span>
    </div>
    <div class="scroll">
      <div class="mainBox" style="padding-top:0">
        <div class="base-info"><span class="line"></span> <span>基础配置</span>
        </div>
        <el-form label-width="130px" :model="form" :rules="rules" ref="form">
          <el-form-item label="桌台区域" required>
            <el-select v-model="tableArea" filterable style="width:620px" value-key="tableAreaCode" clearable>
              <el-option v-for="item in areaList" :key="item.tableAreaCode" :label="item.tableAreaName"
                :value="{ tableAreaCode: item.tableAreaCode, tableAreaName: item.tableAreaName }"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="桌台名称" prop="tableName" required>
            <el-input style="width: 620px" placeholder="请输入桌台名称" v-model="form.tableName"></el-input>
          </el-form-item>
          <el-form-item label="桌台人数" prop="allowPeople" required>
            <el-input @keyup.native.enter="save" style="width:620px" v-model.number="form.allowPeople"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="save">
      <el-button class="cancel" @click="$router.go(-1)">取消</el-button>
      <el-button class="sumbit" :loading="isSubmit" @click="save">保存</el-button>
    </div>


  </div>
</template>

<script>
export default {

  data() {
    return {
      isSubmit: false,
      areaList: [],
      tableArea: '',
      id: '',
      form: {
        merchantName: localStorage.getItem('merchantName'),
        merchantCode: localStorage.getItem('merchantCode'),
        tableName: '',
        allowPeople: 1
      },
      rules: {
        tableName: [
          { required: true, message: '请输入桌台名称', trigger: ['blur', 'change'] },
        ],
        allowPeople: [{ required: true, message: '请输入桌台人数', trigger: ['blur', 'change'] },
        { type: 'number', message: '请填入数字值' }]
      },

    };
  },
  created() {
    this.getArea()
    if (this.$route.query.id != undefined) {
      this.id = this.$route.query.id
      let data = {}
      data.id = this.$route.query.id
      this.queryOne(data)
    }
  },
  methods: {
    async queryOne(data) {
      let ress = await this.$http.post('/merchantAreas/queryOne', data)
      let res = ress.data.data
      this.form.allowPeople = res.allowPeople
      this.form.tableName = res.tableName
      this.$set(this, 'tableArea', { tableAreaCode: res.tableAreaCode, tableAreaName: res.tableAreaName })
    },
    async save() {
      if (this.tableArea == '') {
        this.$message.error('请选择桌台区域')
        return
      }
      if (this.form.allowPeople < 1) {
        this.$message.error('请输入合适的桌台人数')
        return
      }
      if (this.form.tableName == '') {
        this.$message.error('请输入桌台名称')
        return
      }
      let data = {}
      data = this.form
      data.tableAreaName = this.tableArea.tableAreaName
      data.tableAreaCode = this.tableArea.tableAreaCode
      this.isSubmit = true
      if (this.id != '') {
        data.id = this.id
      }
      let res = await this.$http.post('merchantArea/saveMerchantAreaByPC', data)
      this.isSubmit = false
      if (res.data.code == 200) {
        this.$notify({
          title: '提示',
          message: '保存成功',
          type: 'success',
          duration: 1500
        });
        setTimeout(() => {
          this.$router.push('/merchantArea')
        }, 500);
      } else {
        this.$notify({
          title: '提示',
          message: '保存失败',
          type: 'error',
          duration: 1500
        });
      }
    },
    async getArea() {
      let res = await this.$http.post('merchantAreaClass/queryList', { merchantCode: localStorage.getItem('merchantCode') })
      this.areaList = res.data.data
    },
  },
};
</script>

<style lang="less" scoped>
.allBox {
  height: 100%;
  background: #fff;

  .title {
    padding: 6px 20px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;

    span {
      margin-left: 10px;
    }

    i,
    span {
      font-size: 20px;
      font-weight: 500;
    }
  }

  .href {
    display: flex;
    align-items: center;
    height: 48px;
    border-bottom: 1px solid rgb(229, 229, 229);
    overflow: hidden;
    padding-left: 4px;

    // padding: 6px 20px;
    .item {
      padding: 7px 16px;
      overflow: hidden;
      color: rgb(51, 51, 51);
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;

      span {
        cursor: pointer;
        transition: all 0.3s ease 0s;
      }

      span:hover {
        color: rgb(255, 96, 0);
      }
    }
  }

  .mainBox {
    padding: 24px;

    .card {
      border: 1px solid rgb(232, 232, 232);
      border-radius: 2px;
      transition: all 0.3s ease 0s;

      .cardBody {
        padding: 24px;
        display: flex;

        .left {
          margin-right: 16px;

          img {
            width: 48px;
            height: 48px;
          }
        }

        .right {
          .top {
            margin-bottom: 8px;
            overflow: hidden;
            color: rgb(51, 51, 51);
            font-weight: 500;
            font-size: 16px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .bottom {
            color: rgb(102, 102, 102);
            font-size: 14px;
          }
        }
      }
    }
  }
}

.textTitle {
  position: relative;
  right: 24px;
  padding-left: 24px;
  font-size: 16px;
  line-height: 24px;
  width: max-content;
  border-left: none;
  margin-bottom: 16px;
  margin-top: 16px;
  background-image: linear-gradient(270deg,
      rgba(255, 189, 0, 0),
      rgba(255, 202, 0, 0.14) 49%,
      rgba(255, 208, 0, 0.3));
  color: rgb(34, 34, 34);
  font-weight: 500;
  border: none;
}

.diaBox {
  margin-top: 8px;
  background: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 16px;
  margin-left: 112px;

  .inner {
    display: flex;

    .left {
      display: flex;
      width: 120px;
      justify-content: flex-end;
      color: #333;
      font-size: 14px;
    }

    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      color: #333;
      font-size: 14px;

      .top {
        .select {
          color: #ff6000;
          cursor: pointer;
        }

        .c9 {
          color: #999;
        }
      }

      .bottom {
        max-height: 84px;
        overflow: auto;
        display: flex;
        flex-wrap: wrap;
        // border: 1px solid rgb(229, 229, 229);
        padding: 5px;
        padding-bottom: 4px;
        line-height: 32px;
        background-color: #fff;

        .item {
          box-sizing: border-box;
          color: rgb(51, 51, 51);
          height: auto;
          margin: 6px 8px 0px 0px;
          padding: 0px 7px;
          font-size: 12px;
          line-height: 20px;
          white-space: nowrap;
          background: rgb(250, 250, 250);
          border: 1px solid rgb(229, 229, 229);
          border-radius: 4px;
          cursor: default;
          user-select: none;
        }
      }
    }
  }
}

/deep/ .el-form-item__label::after,
.pcfn::after {
  content: ":";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}

/deep/ .noDot>.el-form-item__label::after,
.pcfn::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0px 0px 0px 2px;
}

/deep/ .labelMore {
  color: rgb(102, 102, 102);
  font-size: 14px;
}

/deep/ .scroll {
  height: calc(100vh - 200px);
  overflow: auto;
  scroll-behavior: smooth;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #ffbd00;
}

/deep/ .el-checkbox__input.is-checked {
  .el-checkbox__inner {
    background-color: #ffbd00;
    border-color: #ffbd00;
  }
}

/deep/ .el-checkbox__inner:hover {
  border-color: #ffbd00;
}

/deep/ .el-checkbox__inner:active {
  border-color: #ffbd00;
}

/deep/ .el-checkbox__label {
  color: #606266 !important;
}

/deep/ .el-radio__label {
  color: #606266 !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #ffbd00;
  border-color: #ffbd00;
}

/deep/ .f6 {
  color: #ff6000;
  font-size: 14px;
  cursor: pointer;
}

/deep/ .flexLabel>div {
  display: flex;
}

/deep/ .el-checkbox__input.is-indeterminate {
  .el-checkbox__inner {
    background-color: #fff;
    border-color: #dcdfe6;
  }
}

/deep/ .el-checkbox:last-of-type,
.el-checkbox {
  margin-right: 10px;
}

/deep/ .suffixIcon {
  padding: 0 11px;
  // background-color: rgb(250,250,250);
  color: #333;
  // border-radius: 4px;
  // border: 1px solid rgb(229,229,229);
}

/deep/ label.el-radio {
  margin-right: 16px;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
}

/deep/ .myTextArea {
  textarea {
    height: 77px;
    color: #333;
    font-size: 14px;
  }

  textarea:focus {
    border-color: #ffbd00;
  }
}

/deep/ .el-button.is-circle {
  border-radius: 50%;
  margin-left: 8px;
  background-color: #ffbd00;
  height: 24px;
  width: 24px;

  i {
    font-weight: 700;
    transform: translate(-2px, -1px);
    color: #000;
  }

  i:hover {
    color: #000;
  }
}

.save {
  padding: 10px 32px;
  text-align: right;
  background: transparent;
  border-top: 1px solid rgb(232, 232, 232);
  border-radius: 0px 0px 4px 4px;
  display: flex;
  justify-content: right;
  font-weight: 400;

  .sumbit {
    background-color: #ffbd00;
    color: #000;
  }

  .sumbit:hover {
    opacity: 0.8;
  }

  .cancel:hover {
    background-color: #fff;
    color: rgb(254, 140, 0);
    border: 1px solid #dcdfe6;
  }
}

/deep/.el-main {
  height: 100vh;
}

.hasSelectBox {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.pd24 {
  padding: 24px;
}

.nameItem {
  margin: 0px 3px 3px 0px;
}

.select {
  color: #ff6000;
  cursor: pointer;
}

.mr5 {
  margin-right: 5px;
  margin-bottom: 5px;
}

.sumbit {
  background-color: #ffbd00;
  border: none;
  color: #000;
}

.sumbit:hover {
  opacity: 0.8;
}

.cancel:hover {
  background-color: #fff;
  color: rgb(254, 140, 0);
  border: 1px solid #dcdfe6;
}

.tips {
  margin-top: 20px;
  margin-bottom: 18px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 16px;
  white-space: nowrap;
}

.dishesBox {
  padding: 5px;
  border: 1px solid rgb(229, 229, 229);
}

//   .el-radio-group{
//     display: flex;
//     align-items: center;
//   }
/deep/ .rr label {
  line-height: 20px;
}

/deep/ .tableFlex {
  display: flex;
  flex-direction: column;
}

/deep/ .newBox {
  background: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
}

.line {
  display: inline-block;
  width: 4px;
  height: 18px;
  background-color: #ffbd00;
  margin-right: 5px;
  border-radius: 2px;
  margin-bottom: -2px;
}

.base-info {
  margin: 30px 0 30px 20px;
}

/deep/.el-table thead {
  color: #333;

  font-size: 14px;

  div {
    font-weight: 400 !important;
    background-color: #fafafa;
  }
}

/deep/ thead tr {
  height: 60px;
}
</style>